import React from 'react';
import style from './userInfoContainer.module.css';
import UserDataProfileContainer from './UserProfileComponents/UserDataProfileContainer.jsx';
import StatusProfile from './UserProfileComponents/Status/StatusProfile.jsx';
import { setUserPhotoThunk } from '../../../../../redux/reducers/profile-reducer.js';
import { useDispatch } from 'react-redux';
import AvatarProfile from './UserProfileComponents/Avatar/AvatarProfile.jsx';

const UserInfoContainer = (props) => {
    const dispatch = useDispatch();

    const fileChangeHandler = (event) => {
        if (event.target.files.length) {
            dispatch(setUserPhotoThunk({
                image: event.target.files[0]
            }));
        }
    };
    
    return (
        <div className={style.userContainer}>
            <AvatarProfile
                authId={props.authId} userId={props.userInfo.userId}
                photo={props.userInfo.photos.small}
                error={props.errors.avatar}
                fileChangeHandler={fileChangeHandler} />
            <div className={style["user-info"]}>
                <label>{props.userInfo.fullName}</label>
                <StatusProfile />
                <UserDataProfileContainer contacts={props.userInfo.contacts}
                    error={props.errors.editForm}
                    aboutMe={props.userInfo.aboutMe}
                    lookingForAJob={props.userInfo.lookingForAJob}
                    lookingForAJobDescription={props.userInfo.lookingForAJobDescription} />
            </div>
        </div>
    )
}

export default UserInfoContainer;